module.exports = __webpack_public_path__ + "img/img-box-about-hello-left.3fcec088.png";